// src/api.ts
import axios from 'axios';
import { baseURL, getToken } from './common/utils';

const api = axios.create({
  baseURL: baseURL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    'Content-Type': 'multipart/form-data',
  },
});

// You can add interceptors here for auth tokens

export default api;


// import axios from "axios"
// import { getToken } from "./common/utils"

// const api = axios.create({
//   baseURL: "http://208.115.219.94/~beninclu/bar/",
//   headers: {
//     "Content-Type": "multipart/form-data",
//   },
// })

// // Add request interceptor to include the auth token on each request
// api.interceptors.request.use(
//   (config) => {
//     const token = getToken()
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`
//     }
//     return config
//   },
//   (error) => {
//     return Promise.reject(error)
//   },
// )

// // Add response interceptor to handle common errors
// api.interceptors.response.use(
//   (response) => {
//     return response
//   },
//   (error) => {
//     // Handle common errors like 401 Unauthorized
//     if (error.response && error.response.status === 401) {
//       // Handle unauthorized access - could redirect to login
//       console.error("Unauthorized access. Please log in again.")
//       // You could redirect to login or dispatch a logout action here
//     }
//     return Promise.reject(error)
//   },
// )

// export default api


